import { appShellFromWindow, isNewNativeAppShell } from "constants/appShell";
import { sendWebViewEvent } from "@Utils/webviewEvents";
import { WEB_VIEW_APP_EVENTS } from "@Utils/webApputils/analyticEvents";

/**
 * Tells the native shell that one of this site's hearts changed a property's wishlist state.
 *
 * The hybrid shells draw their own wishlist UI from their own copy of the shortlist — the badge
 * on the tab icon, the hearts on their native property cards, the Wishlist tab's list. None of
 * it hears about a heart tapped in here, because the heart POSTs the shortlist itself: from the
 * shell's side a property wishlisted on the search results or the property page simply never
 * happened. This is the announcement that closes that gap, and it is deliberately the *change*
 * rather than a snapshot, because "added just now" is what the badge is for.
 *
 * Sent from the two API helpers every heart on the site goes through rather than from the
 * hearts themselves, so a new one cannot forget it.
 */
export const publishWishlistChange = (inventoryId: unknown, wishlisted: boolean): void => {
  if (typeof window === "undefined") return;
  // Only the hybrid shells. The RN app owns no wishlist UI of its own — the website is the
  // whole screen there — so it has nothing to tell.
  if (!isNewNativeAppShell(appShellFromWindow())) return;

  const id = Number(inventoryId);
  if (!Number.isFinite(id) || id <= 0) return;

  try {
    sendWebViewEvent(WEB_VIEW_APP_EVENTS.WISHLIST_UPDATED, { inventoryId: id, wishlisted });
  } catch {
    // The bridge must never break a heart tap.
  }
};

export default publishWishlistChange;
